import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { Company } from '../../classess/company/company';
import { GlobalFormats } from '../../classess/main/globalFormats';

import {
    LoadingSection, dataTableLanguaje, setDateTimeFormatGlobalString, isUndNullEmp, getLanguageObj, getResponse, setNumberFour, setSeparatorsNumbers,
    settings, handleResponseMessageAsync
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { Customer } from '../../classess/customer/customer';
import { StatementAccount } from '../../classess/sales/statementAccount';
import { DigitizedDocument } from '../../classess/main/digitizedDocument';
import { SaleService } from '../../services/purchases/SaleService';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, icons, images, labels, messages, } = settings;

const currentMethod = 'SaleDetailDocuments';

export default function SaleDetailDocuments({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const { id = 0, customerId = 0, docType = '', docNumber = 0, } = useParams();
    const auth = useAuth();
    const isMount = useRef(true);
    const dtDocumentDetailsId = 'dtDocumentDetails';
    const dtDocumentDigitizedsId = 'dtDocumentDigitizeds';

    const [process, setProcess] = useState({
        showLoading: false,
    });
    const [showData, setShowData] = useState(true);
    const [company, setCompany] = useState(Company?.getClass({}, false));
    const [customer, setCustomer] = useState(Customer?.getClass({}, false));
    const [documentHeader, setDocumentHeader] = useState(StatementAccount?.getClass({}, false));

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnBack',
            },
        },
        icons: {
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
    };
    //#endregion variables

    //#region methods
    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let companiesData = [];
            let customersData = [];
            let documentDataHeader = {};
            let documentDataDetails = [];
            let documentDataDigitizeds = [];
            //#endregion variables

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                setProcess(prev => ({ ...prev, showLoading: true }));
                setShowData(true);

                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region get data (statement account)
                response = await SaleService.getDetailDocumentsAsync({
                    token: auth?.user?.token?.token,
                    companyId: parseInt(id),
                    customerId: parseInt(customerId),
                    docType: docType,
                    docNumber: parseInt(docNumber),
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                companiesData = response?.result?.companies || [];
                setCompany(prev => (companiesData[0] || {}));
                customersData = response?.result?.customers || [];
                setCustomer(prev => (customersData[0] || {}));
                documentDataHeader = response?.result?.document?.header || {};
                setDocumentHeader(prev => documentDataHeader);
                documentDataDetails = response?.result?.document?.details || [];
                documentDataDigitizeds = response?.result?.document?.digitized || [];
                //#endregion get data (statement account)

                //#region set datatable data
                response = setDataInDataTables({
                    documentDetails: documentDataDetails,
                    documentDigitizeds: documentDataDigitizeds,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set datatable data
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            //#region document details
            $(`#${dtDocumentDetailsId}`).DataTable({
                columns: [
                    { title: labels?.row[languageObj?.id], orderable: false, width: '6%', },
                    { title: labels?.description?.[languageObj?.id], orderable: false, width: '64%', },
                    { title: labels?.quantity[languageObj?.id], orderable: false, className: 'text-right', width: '10%', },
                    { title: labels?.cost[languageObj?.id], orderable: false, className: 'text-right', width: '10%', },
                    { title: labels?.subTotal[languageObj?.id], orderable: false, className: 'text-right', width: '10%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: false,
                info: false,
                autoWidth: false,
                paging: false,
                searching: false,
            });
            //#endregion document details

            //#region document digitized
            $(`#${dtDocumentDigitizedsId}`).DataTable({
                columns: [
                    { title: labels?.row[languageObj?.id], orderable: false, width: '6%', },
                    { title: labels?.type?.[languageObj?.id], orderable: false, width: '10%', },
                    { title: labels?.document?.[languageObj?.id], orderable: false, width: '30%', },
                    { title: labels?.description?.[languageObj?.id], orderable: false, width: '40%', },
                    { title: labels?.file[languageObj?.id], className: 'text-center', orderable: false, width: '14%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: false,
                info: false,
                autoWidth: false,
                paging: false,
                searching: false,
            });
            //#endregion document digitized
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTables = ({
        documentDetails = [],
        documentDigitizeds = [],
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataInDataTables';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let documentDetailsDt = [];
            let documentDigitizedsDt = [];
            //#endregion variables

            //#region process
            //#region document details
            documentDetails.forEach((detail) => {
                documentDetailsDt.push([
                    detail.rowNumber,
                    detail.description,
                    setSeparatorsNumbers({ number: detail.quantity, withDecimals: true })?.result,
                    setSeparatorsNumbers({ number: detail.cost1, withDecimals: true })?.result,
                    setSeparatorsNumbers({ number: setNumberFour({ number: (detail.quantity * detail.cost1), type: 'd' })?.result, withDecimals: true })?.result,
                ]);
            });

            $(`#${dtDocumentDetailsId}`)?.DataTable()?.rows?.add(documentDetailsDt)?.draw(true);
            //#endregion document details

            //#region document digitizeds
            documentDigitizeds.forEach((detail) => {
                const modelDigitizedDocument = DigitizedDocument?.getClass(detail, false);
                const urlDownloadFile = !isUndNullEmp({ data: modelDigitizedDocument?.urlDownload, subMethod: currentMethod })?.result ?
                    `<a href='${modelDigitizedDocument?.urlDownload}' download='${modelDigitizedDocument?.name}' target='_blank' rel='noopener noreferrer'><img alt='pdfAvailableIcon' src='${images?.icons?.pdfAvailableIcon}' height='30' width='25'/></a>` :
                    `<img alt='pdfNoAvailableIcon' src='${images?.icons?.pdfNoAvailableIcon}' height='30' width='25'/>`
                documentDigitizedsDt.push([
                    modelDigitizedDocument?.rowNumber,
                    modelDigitizedDocument?.type,
                    modelDigitizedDocument?.numberStr,
                    modelDigitizedDocument?.description,
                    urlDownloadFile,
                ]);
            });

            $(`#${dtDocumentDigitizedsId}`)?.DataTable()?.rows?.add(documentDigitizedsDt)?.draw(true);
            //#endregion document digitizeds

            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={app?.views?.purchases?.billToPay} process={app?.views?.purchases?.billToPay} languageObj={languageObj} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) - Premium Bar v6.6 */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.detailDocuments?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6 text-center text-sm-right'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0 justify-content-center justify-content-sm-end'>
                                    <li className='breadcrumb-item'><a href='/' className='text-muted'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={backend?.urls?.sales} className='text-muted'>{labels?.billToPay?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={`${backend?.urls?.sales}${backend?.urls?.saleUserCompanyCustomers}/${id}`} className='text-muted'>{labels?.detailCompanyCustomers?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={`${backend?.urls?.sales}${backend?.urls?.saleDetailStatementAccounts}/${id}/${customerId}`} className='text-muted'>{labels?.detailStatementAccounts?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary font-weight-bold'>{labels?.detailDocuments?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                showText={true}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center flex-wrap justify-content-between'>
                                                    <div className='d-flex align-items-center mb-2 mb-md-0'>
                                                        <div className='d-flex flex-column mr-4'>
                                                            <div className='d-flex align-items-center mb-2'>
                                                                <div className='bg-light p-2 rounded-circle mr-2 shadow-sm' style={{ width: '35px', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <img alt={labels?.company?.[languageObj?.id]} style={{ height: '18px' }} src={images?.icons?.company}></img>
                                                                </div>
                                                                <h6 className='mb-0 font-weight-bold text-dark text-uppercase small' style={{ letterSpacing: '0.5px' }}>{company?.name || ''}</h6>
                                                            </div>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='bg-light p-2 rounded-circle mr-2 shadow-sm' style={{ width: '35px', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <img alt={labels?.customers?.[languageObj?.id]} style={{ height: '18px' }} src={images?.icons?.customers}></img>
                                                                </div>
                                                                <h5 className='mb-0 font-weight-bold text-primary'>{customer?.name || ''}</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='ml-auto'>
                                                        <a className={`${controls?.buttons?.back?.defaultClass}`}
                                                            href={`${backend?.urls?.sales}${backend?.urls?.saleDetailStatementAccounts}/${id}/${customerId}`}>
                                                            <i className={controls?.icons?.back?.defaultClass}> </i> {labels?.back?.[languageObj?.id]}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pt-3'>
                                                {/* Document Info Grid */}
                                                <div className='bg-light p-4 rounded shadow-sm mb-4' style={{ borderRadius: '10px' }}>
                                                    <div className='row'>
                                                        <div className='col-md-3 mb-3 mb-md-0'>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.document?.[languageObj?.id]}</small>
                                                            <span className='h6 font-weight-bold text-dark d-block'>
                                                                {!isUndNullEmp({ data: documentHeader, subMethod: currentMethod })?.result && !isUndNullEmp({ data: documentHeader?.tipo_Doc, subMethod: currentMethod })?.result ?
                                                                    `${documentHeader?.tipo_Doc} - ${documentHeader?.nro_Doc}` : '---'}
                                                            </span>
                                                        </div>
                                                        <div className='col-md-3 mb-3 mb-md-0'>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.controlNumber?.[languageObj?.id]}</small>
                                                            <span className='h6 font-weight-bold text-dark d-block'>
                                                                {!isUndNullEmp({ data: documentHeader, subMethod: currentMethod })?.result && !isUndNullEmp({ data: documentHeader?.numcon, subMethod: currentMethod })?.result ?
                                                                    documentHeader?.numcon : '---'}
                                                            </span>
                                                        </div>
                                                        <div className='col-md-3 mb-3 mb-md-0'>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.emision?.[languageObj?.id]}</small>
                                                            <span className='h6 font-weight-bold text-dark d-block'>
                                                                {!isUndNullEmp({ data: documentHeader, subMethod: currentMethod })?.result && !isUndNullEmp({ data: documentHeader?.fec_emis, subMethod: currentMethod })?.result ?
                                                                    setDateTimeFormatGlobalString({
                                                                        date: documentHeader?.fec_emis,
                                                                        dateFormat: languageObj?.format?.date?.f1,
                                                                        timeFormat: 0,
                                                                        withSeconds: false,
                                                                        languageId: languageObj?.id,
                                                                        subMethod: currentMethod,
                                                                    })?.result
                                                                    : '---'}
                                                            </span>
                                                        </div>
                                                        <div className='col-md-3 mb-3 mb-md-0'>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.expiration?.[languageObj?.id]}</small>
                                                            <span className='h6 font-weight-bold text-dark d-block'>
                                                                {!isUndNullEmp({ data: documentHeader, subMethod: currentMethod })?.result && !isUndNullEmp({ data: documentHeader?.fec_Venc, subMethod: currentMethod })?.result ?
                                                                    setDateTimeFormatGlobalString({
                                                                        date: documentHeader?.fec_Venc,
                                                                        dateFormat: languageObj?.format?.date?.f1,
                                                                        timeFormat: 0,
                                                                        withSeconds: false,
                                                                        languageId: languageObj?.id,
                                                                        subMethod: currentMethod,
                                                                    })?.result
                                                                    : '---'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className='row mt-4'>
                                                        <div className='col-md-3 mb-3 mb-md-0 d-flex align-items-center'>
                                                            <div className='mr-3'>
                                                                <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.daysToExpire?.[languageObj?.id]}</small>
                                                                <h5 className='mb-0 font-weight-bold text-success'>
                                                                    {!isUndNullEmp({ data: documentHeader, subMethod: currentMethod })?.result && !isUndNullEmp({ data: documentHeader?.nDiaPorVencer, subMethod: currentMethod })?.result ?
                                                                        setSeparatorsNumbers({ number: documentHeader?.nDiaPorVencer, withDecimals: false })?.result : '0'}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-3 mb-3 mb-md-0 d-flex align-items-center'>
                                                            <div className='mr-3'>
                                                                <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.expiredDays?.[languageObj?.id]}</small>
                                                                <h5 className='mb-0 font-weight-bold text-danger'>
                                                                    {!isUndNullEmp({ data: documentHeader, subMethod: currentMethod })?.result && !isUndNullEmp({ data: documentHeader?.nDiaVencido, subMethod: currentMethod })?.result ?
                                                                        setSeparatorsNumbers({ number: documentHeader?.nDiaVencido, withDecimals: false })?.result : '0'}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.description?.[languageObj?.id]}</small>
                                                            <p className='mb-0 text-muted small italic'>
                                                                {!isUndNullEmp({ data: documentHeader, subMethod: currentMethod })?.result && !isUndNullEmp({ data: documentHeader?.observa, subMethod: currentMethod })?.result ?
                                                                    documentHeader?.observa : '---'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Amount Cards */}
                                                {/* <div className='row mb-4'>
                                                    <div className='col-sm-6 col-md-3 mb-3'>
                                                        <div className='p-3 rounded bg-white border shadow-sm h-100 text-center' style={{ borderRadius: '10px' }}>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.netAmountDocument?.[languageObj?.id]}</small>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>
                                                                {!isUndNullEmp({ data: documentHeader, subMethod: currentMethod })?.result && !isUndNullEmp({ data: documentHeader?.monto_Net_Doc, subMethod: currentMethod })?.result ?
                                                                    setSeparatorsNumbers({ number: documentHeader?.monto_Net_Doc, withDecimals: true })?.result : '0.00'}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-6 col-md-3 mb-3'>
                                                        <div className='p-3 rounded bg-white border border-primary shadow-sm h-100 text-center' style={{ borderRadius: '10px', borderTopWidth: '3px' }}>
                                                            <small className='text-muted text-uppercase mb-1 text-primary' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.balanceDocument?.[languageObj?.id]}</small>
                                                            <h5 className='mb-0 font-weight-bold text-primary'>
                                                                {!isUndNullEmp({ data: documentHeader, subMethod: currentMethod })?.result && !isUndNullEmp({ data: documentHeader?.saldo_Doc, subMethod: currentMethod })?.result ?
                                                                    setSeparatorsNumbers({ number: documentHeader?.saldo_Doc, withDecimals: true })?.result : '0.00'}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-6 col-md-3 mb-3'>
                                                        <div className='p-3 rounded bg-white border shadow-sm h-100 text-center' style={{ borderRadius: '10px' }}>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.netAmountOther?.[languageObj?.id]}</small>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>
                                                                {!isUndNullEmp({ data: documentHeader, subMethod: currentMethod })?.result && !isUndNullEmp({ data: documentHeader?.monto_Net_Nde1, subMethod: currentMethod })?.result ?
                                                                    setSeparatorsNumbers({ number: documentHeader?.monto_Net_Nde1, withDecimals: true })?.result : '0.00'}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-6 col-md-3 mb-3'>
                                                        <div className='p-3 rounded bg-white border border-info shadow-sm h-100 text-center' style={{ borderRadius: '10px', borderTopWidth: '3px' }}>
                                                            <small className='text-muted text-uppercase mb-1 text-info' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>{labels?.balanceOther?.[languageObj?.id]}</small>
                                                            <h5 className='mb-0 font-weight-bold text-info'>
                                                                {!isUndNullEmp({ data: documentHeader, subMethod: currentMethod })?.result && !isUndNullEmp({ data: documentHeader?.saldo_Nde1, subMethod: currentMethod })?.result ?
                                                                    setSeparatorsNumbers({ number: documentHeader?.saldo_Nde1, withDecimals: true })?.result : '0.00'}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div> */}

                                                <div className='row text-center align-items-center'>
                                                    <div className='col-sm-6 col-md-3 mb-3 mb-md-0'>
                                                        <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>
                                                                {labels?.netAmountDocument?.[languageObj?.id]}
                                                            </small>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>
                                                                {setSeparatorsNumbers({ number: documentHeader.monto_Net_Doc, withDecimals: true, })?.result || '0.00'}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-6 col-md-3 mb-3 mb-md-0'>
                                                        <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>
                                                                {labels?.balanceDocument?.[languageObj?.id]}
                                                            </small>
                                                            <h5 className='mb-0 font-weight-bold text-primary'>
                                                                {setSeparatorsNumbers({ number: documentHeader.saldo_Doc, withDecimals: true, })?.result || '0.00'}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-6 col-md-3 mb-3 mb-md-0'>
                                                        <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>
                                                                {labels?.netAmountOther?.[languageObj?.id]}
                                                            </small>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>
                                                                {setSeparatorsNumbers({ number: documentHeader.monto_Net_Nde1, withDecimals: true, })?.result || '0.00'}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-6 col-md-3 mb-3 mb-md-0'>
                                                        <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>
                                                                {labels?.balanceOther?.[languageObj?.id]}
                                                            </small>
                                                            <h5 className='mb-0 font-weight-bold text-info'>
                                                                {setSeparatorsNumbers({ number: documentHeader.saldo_Nde1, withDecimals: true, })?.result || '0.00'}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Details Table */}
                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.fileAlt} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.informationDocuments?.[languageObj?.id]}</h6>
                                                </div>
                                                <TableIndex tableId={dtDocumentDetailsId} languageObj={languageObj} />


                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.folderOpen} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.digitizedDocuments?.[languageObj?.id]}</h6>
                                                </div>
                                                <TableIndex tableId={dtDocumentDigitizedsId} languageObj={languageObj} />
                                            </div>

                                            <div className='card-footer bg-white border-top-0 pb-4 px-4 pt-0 mt-3'>
                                                <div className='row text-center align-items-center'>
                                                    <div className='col-md-6 d-none d-md-flex justify-content-start align-items-center'>
                                                        <div className='text-right mr-3'>
                                                            <small className='text-muted d-block'>{messages?.processCompletedSuccessfully?.[languageObj?.id]}</small>
                                                            <span className='badge badge-success px-3 shadow-sm'>{labels?.detailDocuments?.[languageObj?.id]}</span>
                                                        </div>
                                                        <i className='fas fa-file-invoice text-muted fa-2x opacity-25'></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}

                    </div>
                </section >

            </div>
        </div>
    )
}